export const PLATFORM_ROOT = '/platform';
export const LOGIN_URL = `${PLATFORM_ROOT}/login`;
export const SIGNUP_URL = `${PLATFORM_ROOT}/sign-up`;
export const PLATFORM_TOS_URL = '/platform/tos';
export const USER_TOS_URL = '/terms';
export const PRIVACY_POLICY_URL = '/privacy';
